import normalizePriceData from '~/assets/services/price/normalizeData';
import normalizeProductData from './product';

export default function (sourceData = {}) {
    return {
        ...normalizeProductData(sourceData),
        ...normalizePriceData(sourceData),
    };
}
